import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import './ConsentFlow/ConsentFlow.scss'
import { withRouting } from '../common/hooks'
import Input from '../common/form/Input'
import { connect } from 'react-redux'
import { withTranslation, Trans } from 'react-i18next'
import { signOutUser } from '../../actions/authActions'
import { FAMILY_ADMIN_MIN_AGE } from '../../misc/Constants'
import { validatePhoneForTwilio } from '../../utility/helperFunctions'
import PropTypes from 'prop-types'

const UPDATE_BIRTHDATE_URL = `${process.env.REACT_APP_OAUTH_PROVIDER_HOST}/profile/edit`

const CONSENT_NAMES = {
  privacy_policy: 'consent.docName.privacyPolicy',
  eula: 'consent.docName.termsOfUse',
  saas_agreement: 'consent.docName.coachEula',
}

const FAMILY_CONSENT_NAMES = {
  privacy_policy: 'consent.docName.privacyPolicy',
  eula: 'consent.docName.termsOfUse',
  coppa_policy: 'consent.docName.coppaPolicy',
}

class ConsentContainer extends Component {
  state = {
    allConsentCheckbox: false,
    over12Checkbox: false,
    submitting: false,
    birthdate: moment(),
    birthdateError: null,
    phone: '',
    phonePrefix: '',
    phonePrefixCountry: '',
    phoneError: null,
    promotionalTextMessages: false,
    familyAgeSkipped: false,
    familyAges: {},
    loadingFamilyAges: true,
    familyConsentsSkipped: false,
    familyConsentsCheckbox: false,
    submittingFamily: false,
  }

  componentDidMount() {
    this._initializeFamilyAgesObj()
  }

  componentDidUpdate() {
    if (this.state.loadingFamilyAges) {
      this._initializeFamilyAgesObj()
    }
  }

  // eslint-disable-next-line max-lines-per-function, complexity
  render() {
    const { consents, consentType } = this.props

    if (!consents) {
      return null
    }

    const {
      allConsentCheckbox,
      over12Checkbox,
      submitting,
      birthdate,
      birthdateError,
      phone,
      phoneError,
      promotionalTextMessages,
      familyAgeSkipped,
      familyAges,
      loadingFamilyAges,
      familyConsentsSkipped,
      familyConsentsCheckbox,
      submittingFamily,
    } = this.state

    const needsPersonalConsent = this._getConsentsNeeded(consents).length > 0

    if (consentType === 'userAge') {
      return (
        <div id='ConsentContainer'>
          <h2>{this.props.t('consent.container.userAgeHeading')}</h2>

          <p className='subtext'>
            <Trans
              i18nKey='consent.container.userAgeSubtext'
              components={{
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                termsLink: <a href='https://operation36.golf/legal/' target='_blank' rel='noopener noreferrer' />,
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                privacyLink: <a href='https://operation36.golf/legal/' target='_blank' rel='noopener noreferrer' />,
              }}
            />
          </p>

          <p className='bold mb-0'>{this.props.t('consent.container.inputBirthdate')}</p>

          <DatePicker
            selected={birthdate.toDate()}
            onChange={this._handleBirthdateChange}
          />

          {birthdateError && <p className='error'>{birthdateError}</p>}

          <button
            onClick={this._submitOwnBirthdateChange}
            className='btn-rectangular btn-rectangular-main-positive mt-4'
            disabled={!birthdate}
          >
            {submitting ? this.props.t('consent.common.continuing') : this.props.t('common.action.continue')}
          </button>
        </div>
      )
    }

    if (consentType === 'contactSupport') {
      return (
        <div id='ConsentContainer'>
          <h2>{this.props.t('consent.container.contactSupportHeading')}</h2>

          <p className='subtext'>
            <Trans
              i18nKey='consent.container.contactSupportSubtext'
              components={{ emailSpan: <span className='orange' /> }}
            />
          </p>
          <button
            onClick={this._updateBirthdate}
            className='btn-rectangular btn-rectangular-main-positive mt-4 d-flex align-items-center justify-content-center'
          >
            {this.props.t('consent.container.updateBirthdateCta')}
            <i className='fa fa-external-link ml-2 external-link-icon' aria-hidden='true' />
          </button>
          <button onClick={this._signOut} className='btn-rectangular btn-rectangular-main-negative mt-2'>
            {this.props.t('common.logOut')}
          </button>
        </div>
      )
    }

    if (consentType === 'needsProxy') {
      return (
        <div id='ConsentContainer'>
          <h2>{this.props.t('consent.container.needsProxyHeading')}</h2>

          <p className='subtext'>
            {this.props.t('consent.container.needsProxySubtext')}
          </p>

          <p className='bold mb-0'>{this.props.t('consent.container.askFamilyMembers')}</p>
          <ul>
            {consents.needs_proxy.map((fam_ad, i) => (
              <li key={i}>{fam_ad}</li>
            ))}
          </ul>
          <button onClick={this._signOut} className='btn-rectangular btn-rectangular-main-positive mt-4'>
            {this.props.t('common.logOut')}
          </button>
        </div>
      )
    }

    if (consents.family_ages_needed && consents.family_ages_needed.length > 0 && !familyAgeSkipped) {
      return (
        <div id='ConsentContainer'>
          <h2>{this.props.t('consent.container.familyAgesHeading')}</h2>
          <p className='subtext'>
            <Trans
              i18nKey='consent.container.familyAgesSubtext'
              components={{
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                termsLink: <a href='https://operation36.golf/legal/' target='_blank' rel='noopener noreferrer' />,
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                privacyLink: <a href='https://operation36.golf/legal/' target='_blank' rel='noopener noreferrer' />,
              }}
            />
          </p>
          <p className='bold mb-0'>{this.props.t('consent.container.inputBirthdays')}</p>
          {loadingFamilyAges ? (
            <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          ) : (
            consents.family_ages_needed.map((usr) => (
              <div
                className='d-flex align-items-center justify-content-between'
                key={usr[0]}
              >
                <p className='mb-0'>{familyAges[usr[0]].name}</p>
                <DatePicker
                  selected={familyAges[usr[0]].birthdate}
                  onChange={(data) =>
                    this._handleFamilyBirthdateChange(usr[0], data)
                  }
                />
              </div>
            ))
          )}
          <div className='d-flex mt-4'>
            <button
              onClick={this._skipFamilyAges}
              className='btn-rectangular btn-rectangular-main-negative mt-4'
            >
              {this.props.t('consent.common.skip')}
            </button>
            <button
              onClick={this._submitFamilyAges}
              className='btn-rectangular btn-rectangular-main-positive mt-4'
              disabled={this._anyMissingFamilyAges()}
            >
              {this.props.t('common.action.submit')}
            </button>
          </div>
        </div>
      )
    }

    if (consents.family_consents_needed && consents.family_consents_needed.length > 0 && !familyConsentsSkipped) {
      return (
        <div id='ConsentContainer'>
          <h2>{this.props.t('consent.container.familyConsentsHeading')}</h2>
          <p className='subtext'>
            {this.props.t('consent.container.familyConsentsSubtext')}
          </p>
          <p className='bold mb-0'>{this.props.t('consent.common.consentRequiredFor')}</p>
          <ul>{this._renderFamilyConsentLinks()}</ul>

          <div className='checkbox-container mt-2'>
            <div
              role='checkbox'
              aria-checked={familyConsentsCheckbox}
              tabIndex={0}
              className={`checkbox ${familyConsentsCheckbox ? 'filled' : ''}`}
              onClick={() => this._handleCheckbox('familyConsentsCheckbox')}
              onKeyDown={() => this._handleCheckbox('familyConsentsCheckbox')}
            >
              {familyConsentsCheckbox && (
                <i className='fa fa-check' aria-hidden='true' />
              )}
            </div>
            <span>
              {this.props.t('consent.container.familyConsentStatement')}
            </span>
          </div>
          <div className='d-flex'>
            <button
              onClick={this._skipFamilyConsents}
              className='btn-rectangular btn-rectangular-main-negative mt-4'
            >
              {this.props.t('consent.common.skip')}
            </button>
            <button
              onClick={this._submitFamilyConsent}
              className='btn-rectangular btn-rectangular-main-positive mt-4'
              disabled={!familyConsentsCheckbox || submittingFamily}
            >
              {submittingFamily ? this.props.t('consent.common.continuing') : this.props.t('common.action.continue')}
            </button>
          </div>
        </div>
      )
    }

    if (consents.phone_needed) {
      return (
        <div id='ConsentContainer'>
          <h2>{this.props.t('consent.container.phoneNeededHeading')}</h2>

          <p className='subtext'>
            <Trans
              i18nKey='consent.container.phoneNeededSubtext'
              components={{
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                termsLink: <a href='https://operation36.golf/legal/' target='_blank' rel='noopener noreferrer' />,
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                privacyLink: <a href='https://operation36.golf/legal/' target='_blank' rel='noopener noreferrer' />,
              }}
            />
          </p>

          <p className='bold mb-0'>{this.props.t('consent.container.enterPhoneLabel')}</p>

          <Input
            type='telephone'
            id='phone'
            name='phone'
            classNames={{ inputContainerWrapper: 'mt-2' }}
            onChange={this._handlePhoneChange}
            error={phoneError}
          />

          <div className='checkbox-container mt-2'>
            <div
              role='checkbox'
              aria-checked={promotionalTextMessages}
              tabIndex={0}
              className={`checkbox ${promotionalTextMessages ? 'filled' : ''}`}
              onClick={() => this._handleCheckbox('promotionalTextMessages')}
              onKeyDown={() => this._handleCheckbox('promotionalTextMessages')}
            >
              {promotionalTextMessages && <i className='fa fa-check' aria-hidden='true' />}
            </div>
            <span>{this.props.t('consent.container.agreeTextMessages')}</span>
          </div>
          <p className='fine-print'>
            {this.props.t('consent.container.textConsentFinePrint')}
          </p>

          <button
            onClick={this._submitOwnPhoneChange}
            className='btn-rectangular btn-rectangular-main-positive mt-4'
            disabled={!phone}
          >
            {this.props.t('common.action.continue')}
          </button>
        </div>
      )
    }

    if (needsPersonalConsent) {
      return (
        <div id='ConsentContainer'>
          <h2>{this.props.t('consent.container.personalConsentHeading')}</h2>
          <p className='subtext'>
            {this.props.t('consent.container.personalConsentSubtext')}
          </p>

          <p className='bold mb-0'>{this.props.t('consent.common.consentRequiredFor')}</p>
          <ul>{this._renderConsentLinks()}</ul>

          <div className='checkbox-container'>
            <div
              role='checkbox'
              aria-checked={over12Checkbox}
              tabIndex={0}
              className={`checkbox ${over12Checkbox ? 'filled' : ''}`}
              onClick={() => this._handleCheckbox('over12Checkbox')}
              onKeyDown={() => this._handleCheckbox('over12Checkbox')}
            >
              {over12Checkbox && (
                <i className='fa fa-check' aria-hidden='true' />
              )}
            </div>
            <span>{this.props.t('consent.container.agreeAge13')}</span>
          </div>
          <div className='checkbox-container mt-2'>
            <div
              role='checkbox'
              aria-checked={allConsentCheckbox}
              tabIndex={0}
              className={`checkbox ${allConsentCheckbox ? 'filled' : ''}`}
              onClick={() => this._handleCheckbox('allConsentCheckbox')}
              onKeyDown={() => this._handleCheckbox('allConsentCheckbox')}
            >
              {allConsentCheckbox && (
                <i className='fa fa-check' aria-hidden='true' />
              )}
            </div>
            <span>
              {this.props.t('consent.common.boundByTerms')}
            </span>
          </div>
          <button
            onClick={this._submitConsent}
            className='btn-rectangular btn-rectangular-main-positive mt-4'
            disabled={!over12Checkbox || !allConsentCheckbox || submitting}
          >
            {submitting ? this.props.t('consent.common.continuing') : this.props.t('common.action.continue')}
          </button>
        </div>
      )
    }

    if (familyAgeSkipped || familyConsentsSkipped) {
      return this._shutHerDown()
    }

    return null
  }

  _shutHerDown = () => {
    // they skipped all the family stuff and don't have personal consents
    this.props.closeModal()
    return null
  }

  _renderFamilyConsentLinks = () => {
    const { consents } = this.props
    return consents.family_consents_needed.map((usr) => (
      <li key={usr.id}>
        {usr.name}
        <ul>{this._renderFamilyIndividualConsents(usr)}</ul>
      </li>
    ))
  }

  _renderFamilyIndividualConsents = (usr) => {
    const consentsNeeded = []
    Object.keys(FAMILY_CONSENT_NAMES).forEach((consent) => {
      if (!usr[consent]) {
        consentsNeeded.push(consent)
      }
    })
    return consentsNeeded.map((consent, idx) => (
      <li key={idx}>
        <a
          href='https://operation36.golf/legal/'
          target='_blank'
          rel='noopener noreferrer'
        >
          {this.props.t(FAMILY_CONSENT_NAMES[consent])}
        </a>
      </li>
    ))
  }

  _submitFamilyConsent = () => {
    this.setState({ submittingFamily: true }, () => {
      this.props.submitFamilyConsents()
    })
  }

  _submitFamilyAges = () => {
    const { submitFamilyBirthdates } = this.props
    const { familyAges } = this.state
    const userArray = []
    for (const [id, data] of Object.entries(familyAges)) {
      if (Object.prototype.hasOwnProperty.call(familyAges, id)) {
        userArray.push({ id: id, birthdate: data.birthdate })
      }
    }
    submitFamilyBirthdates(userArray)
  }

  _skipFamilyConsents = () => {
    this.setState({ familyConsentsSkipped: true })
  }

  _skipFamilyAges = () => {
    this.setState({ familyAgeSkipped: true })
  }

  _anyMissingFamilyAges = () => {
    const { familyAges, loadingFamilyAges } = this.state
    if (loadingFamilyAges) {
      return true
    }
    let ret = false
    for (const property in familyAges) {
      if (Object.prototype.hasOwnProperty.call(familyAges, property)) {
        if (!familyAges[property].birthdate) {
          ret = true
        }
      }
    }
    return ret
  }

  _handleFamilyBirthdateChange = (id, date) => {
    const { familyAges } = this.state
    const familyAgesCopy = Object.assign({}, familyAges)
    familyAgesCopy[id].birthdate = date
    this.setState({ familyAges: familyAgesCopy })
  }

  _initializeFamilyAgesObj = () => {
    const { consents } = this.props
    const { familyAges } = this.state
    if (
      !consents.family_ages_needed ||
      consents.family_ages_needed.length === 0
    ) {
      return
    }
    const newFamilyObj = Object.assign({}, familyAges)
    consents.family_ages_needed.forEach((usr) => {
      newFamilyObj[usr[0]] = { name: `${usr[1]} ${usr[2]}`, birthdate: null }
    })
    this.setState({ familyAges: newFamilyObj, loadingFamilyAges: false })
  }

  _isFamilyAdminUnderMinAge = () => {
    const { currentUser } = this.props
    const { birthdate } = this.state

    return Boolean(currentUser?.family_admin) && moment().diff(birthdate, 'years') < FAMILY_ADMIN_MIN_AGE
  }

  _submitOwnBirthdateChange = () => {
    const { birthdate } = this.state
    const { submitOwnBirthdate } = this.props

    if (this._isFamilyAdminUnderMinAge()) {
      this.setState({ birthdateError: this.props.t('consent.container.minAgeError', { age: FAMILY_ADMIN_MIN_AGE }) })
      return
    }

    submitOwnBirthdate(birthdate)
  }

  _handlePhoneChange = ({ phone, phonePrefix, phonePrefixCountry }) => {
    this.setState({ phone, phonePrefix, phonePrefixCountry, phoneError: null })
  }

  _submitOwnPhoneChange = () => {
    const { phone, phonePrefix, phonePrefixCountry, promotionalTextMessages } = this.state
    const { submitOwnPhone } = this.props

    if (!validatePhoneForTwilio(`${phonePrefix}${phone}`)) {
      this.setState({ phoneError: 'Invalid phone number format' })
      return
    }

    submitOwnPhone({ phone, phonePrefix, phonePrefixCountry, promotionalTextMessages })
  }

  _submitConsent = () => {
    const { consents, submitConsents } = this.props
    const { allConsentCheckbox, over12Checkbox, submitting } = this.state
    if (!over12Checkbox || !allConsentCheckbox || submitting) {
      return false
    }
    this.setState({ submitting: true }, () => {
      const updatedConsents = this._getConsentsNeeded(consents)
      submitConsents(updatedConsents)
    })
  }

  _handleBirthdateChange = (date) => {
    this.setState({ birthdate: moment(date), birthdateError: null })
  }

  _handleCheckbox = (val) => {
    this.setState((prevState) => ({ [val]: !prevState[val] }))
  }

  _renderConsentLinks = () => {
    const { consents } = this.props
    const consentsNeeded = this._getConsentsNeeded(consents)
    return consentsNeeded.map((c, i) => (
      <li key={i}>
        <a
          href='https://operation36.golf/legal/'
          target='_blank'
          rel='noopener noreferrer'
        >
          {this.props.t(CONSENT_NAMES[c.name])}
        </a>
      </li>
    ))
  }

  _getConsentsNeeded = (consents) => {
    const consentArray = []
    for (const [consentName, consentData] of Object.entries(consents)) {
      if (Object.prototype.hasOwnProperty.call(CONSENT_NAMES, consentName)) {
        if (!consentData.consented) {
          consentArray.push({
            name: consentName,
            version: consentData.version,
          })
        }
      }
    }
    return consentArray
  }

  _updateBirthdate = () => {
    window.open(UPDATE_BIRTHDATE_URL, '_blank', 'noopener,noreferrer')
  }

  _signOut = () => {
    this.props.dispatch(signOutUser())
  }
}

ConsentContainer.propTypes = {
  t: PropTypes.func,
  navigate: PropTypes.func,
  dispatch: PropTypes.func,
  currentUser: PropTypes.object,
  consents: PropTypes.object,
  consentType: PropTypes.string,
  closeModal: PropTypes.func,
  submitConsents: PropTypes.func,
  submitFamilyConsents: PropTypes.func,
  submitFamilyBirthdates: PropTypes.func,
  submitOwnBirthdate: PropTypes.func,
  submitOwnPhone: PropTypes.func,
}

export default withRouting(connect()(withTranslation()(ConsentContainer)))
